export default "__VITE_ASSET__CFPwQdQq__"